import React from 'react';

import { ChevronRightIcon } from '@ergeon/icons/hero/micro';
import { Link } from '@ergeon/core-components';

import { useBreadcrumbs } from '../hooks';

const Breadcrumbs: React.FC = () => {
  const breadcrumbs = useBreadcrumbs();

  if (breadcrumbs.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-1 pb-0.5">
      {breadcrumbs.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <ChevronRightIcon className="size-4 text-gray-400 dark:text-gray-600" />}
          {item.path ? (
            <Link className="font-medium text-gray-900 dark:text-white hover:underline paragraph-3" href={item.path} unstyled>
              {item.label}
            </Link>
          ) : (
            <span className="font-medium text-gray-900 dark:text-white paragraph-3">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumbs;
